(function ($, window) {

    var prodigy_product = {
        _weight_type_mapper: ["lbs", "g", "kg", "oz"],
        _dimension_type_mapper: ["in", "cm"],
        _stock_status_mapper: {"in_stock": "In stock", "out_of_stock": "Out of stock"},
        _add_to_cart_key: "add_item_to_cart",
        product: {},
        is_show_subscription_popup: false,
        subscription_price: 0,
        is_subscription_replaced: false,
        is_one_time_order: true,
        subscription_id: '',
        remote_product: {},
        variant: {},
        maxItems: 9999,
        is_admin: false,
        is_tiered_price: false,
        selectedVariant: [],
        master_variant_id: 0,
        active_bulk_attribute_name: '',
        min_quantity: 1,
        add_to_cart_button_element: '.add-to-cart-js',
        enable_bulk_element: '.enable-bulk-js',
        disable_bulk_button_element: '.disable-bulk-button-js',
        product_counter_input_element: '.counter-count-js',
        prodigy_product_swatch_element: '.prodigy-product__swatch-js',
        is_variant_was_chosen: false,
        swiperThumbs: false,
        swiperMain: false,
        main_slider_template: '#gallery-slide',
        thumb_slider_template: '#gallery-thumbs-slide',
        prodigy_personalization_input_element: '.prodigy-personalization__input-js',
        product_stock_element: '.prodigy-product-stock-js',
        product_default_info_price_element: '.product-default-info-price-js',
        prodigy_product_swatch_block_element: '.prodigy-product__swatch-block-js',
        is_variant_gallery: false,
        selected_attributes: [],
        bulk_variants_info: [],


        init: function () {
            this.is_tiered_price = Boolean($('.is_tired_price-js').val());
            if (this.is_tiered_price) {
                localStorage.setItem("min_quantity", this.min_quantity);
            }
            let is_product_page = $("body").hasClass("single-prodigy-product");
            let is_shop_page = $("body").hasClass("tax-prodigy-product-shop");
            this.master_variant_id = $('#product_id').val();
            this.is_admin = $(document).find('#user-role-js').data('attr');

            if (!is_shop_page && is_product_page) {
                if (!this.is_variants()) {
                    this.get_master_variant_data();
                }
                this.set_product_tabs();
                this.set_product_counter();
                this.show_tab_review();
                this.show_tab_description();
                this.send_captcha();
                this.send_review_for_user();
                this.disable_submit_comment();
                this.reset_focus_to_press_enter();
                this.set_default_link_review();
                this.change_product_quantity_analytic_event();
                this.set_product_gallery();
                if (this.is_variants()) {
                    if (this.is_swatches()) {
                        this.change_swatch_value();
                        this.set_checked_swatch();
                    } else {
                        this.set_variant_dropdown();
                        this.set_attribute_value_options();
                        this.update_variants_dropdown();
                    }
                    this.set_customised_variant_selection();
                }
                this.set_variant_data();
                this.set_elementor_options();
                this.set_subscription_id();
                this.customise_sort_select();
                this.add_item_to_cart();
                this.hide_empty_div();
                prodigyProductBulk.set_bulk_variants_data();

                if (prodigyProductBulk.is_active_logo_bulk) {
                    this.set_bulk();
                    $(document).trigger('enable-multiple-quantity');
                }

                if (this.is_swatches()) {
                    this.set_checked_swatch();
                } else {
                    this.set_attribute_value_options();
                }

                if (this.is_personalization()) {
                    this.input_personalization_field();
                }
                if (!prodigyProductBulk.is_active_bulk) {
                    this.show_available_variants();
                }
                if (this.is_tiered_price) {
                    this.get_tiered_prices_range_ajax();
                    this.close_tiered_price_popup();
                }

                if (prodigyProductBulk.is_bulk_enabled()) {
                    let active_bulk_attribute = $('.bulk-container-js:visible').data('attribute');
                    this.set_variant_modifier(active_bulk_attribute);
                }
                this.set_redemption_price();
            }
        },


        set_redemption_price: function () {
            if (parseInt(settings.redemption_store)) {
                $('.prodigy-bulk__subtotal-save').hide();
            } else {
                $('.prodigy-bulk__subtotal-save').show();
            }
        },


        show_available_variants: function () {
            let selected = [];
            let allowed_variants = $('.variants-options-intersect-js').data('options');
            if (this.is_swatches()) {
                $('.prodigy-product__swatch-js:checked').each(function () {
                    let attr_name = $(this).data('attribute');
                    selected[attr_name] = $(this).data('slug');
                });

                $('.prodigy-product__swatch-js').each(function () {
                    let attr_name = $(this).data('attribute');
                    let attr_value = $(this).data('slug');

                    let hide_control = true;
                    for (let i in allowed_variants) {
                        let is_accepted = allowed_variants[i][attr_name] === attr_value;
                        for (let selected_attr_name in selected) {
                            if (attr_name === selected_attr_name) {
                                continue;
                            }
                            is_accepted = is_accepted && allowed_variants[i][selected_attr_name] === selected[selected_attr_name];
                        }

                        if (is_accepted) {
                            hide_control = false;
                            break;
                        }
                    }

                    if (hide_control) {
                        $(this).parent().hide();
                    } else {
                        $(this).parent().show();
                    }
                });
            } else {
                $(".attribute_values_js").each(function () {
                        let $option = $(this).find("option:selected");
                        let attr_value = $option.data('slug');
                        let attr_name = $option.data('attribute');
                        selected[attr_name] = attr_value;
                    }
                );

                $(".attribute_values_js option").each(function () {
                    let attr_value = $(this).data('slug');
                    let attr_name = $(this).data('attribute');
                    let hide_control = true;
                    for (let i in allowed_variants) {
                        let is_accepted = allowed_variants[i][attr_name] === attr_value;
                        for (let selected_attr_name in selected) {
                            if (attr_name === selected_attr_name) {
                                continue;
                            }
                            is_accepted = is_accepted && allowed_variants[i][selected_attr_name] === selected[selected_attr_name];
                        }

                        if (is_accepted) {
                            hide_control = false;
                            break;
                        }
                    }

                    if (hide_control) {
                        $(this).addClass('d-none');
                    } else {
                        $(this).removeClass('d-none');
                    }
                });
            }
        },


        show_available_variants_bulk: function (active_attribute) {
            let selected = [];
            let allowed_variants = $('.variants-options-intersect-js').data('options');

            if (this.is_swatches()) {
                $('.prodigy-product__swatch-js:checked').each(function () {
                    let attr_name = $(this).data('attribute');
                    let attr_value = $(this).data('slug');
                    if (attr_name !== active_attribute) {
                        selected[attr_name] = attr_value;
                    }
                });
            } else {
                $(".attribute_values_js").each(function () {
                        let $option = $(this).find("option:selected");
                        let attr_value = $option.data('slug');
                        let attr_name = $option.data('attribute');
                        if (attr_name !== active_attribute) {
                            selected[attr_name] = attr_value;
                        }
                    }
                );
            }

            $('.bulk-container-js[data-attribute="' + active_attribute + '"]').find('input').each(function () {
                let hide_control = true;
                let attr_value = $(this).data('option');
                for (let i in allowed_variants) {
                    let is_accepted = allowed_variants[i][active_attribute] === attr_value;
                    for (let selected_attr_name in selected) {
                        is_accepted = is_accepted && allowed_variants[i][selected_attr_name] === selected[selected_attr_name];
                    }

                    if (is_accepted) {
                        hide_control = false;
                        break;
                    }
                }

                if (hide_control) {
                    $(this).val('');
                    $(this).attr('disabled', true);
                    $(this).closest('.prodigy-bulk__table-cell-body').addClass('prodigy-bulk__table-cell-body--disabled');
                } else {
                    $(this).attr('disabled', false);
                    $(this).closest('.prodigy-bulk__table-cell-body').removeClass('prodigy-bulk__table-cell-body--disabled');
                }
            });
        },


        close_tiered_price_popup: function () {
            $(document).on('click', '.close-tiered-prices-js', function () {
                $('#minorderQTY').modal('hide');
            })
        },

        get_options: function () {
            let self = this;
            let selected_options = [];
            if (this.is_swatches()) {
                $(self.prodigy_product_swatch_element).each(
                    function () {
                        let swatch_block = $(this).closest(self.prodigy_product_swatch_block_element);
                        if ($(this).is(':checked') && !$(swatch_block).hasClass('ignored')) {
                            let value = $(this).val();
                            $(this).closest('.swatch-container-js').find('.swatch-attribute-name-js').html("&nbsp;" + $(this).val());
                            selected_options.push(value);
                        }
                    }
                );
            } else {
                $(".attribute_values_js").each(function () {
                        let $option = $(this).find("option:selected");
                        if ($option.val() !== '') {
                            selected_options.push($option.val());
                        }
                    }
                );
            }

            return selected_options;
        },

        set_product_gallery: function () {
            let thumbsDirection = 'horizontal';
            let thumbsSlidesPerView = $("#gallery-thumbs").data('slides') || 3;
            let thumbsSpaceBetween = $("#gallery-thumbs").data('spacing') || 10;

            if ($("#gallery").hasClass("prodigy-product__gallery-container--left") || $("#gallery").hasClass("prodigy-product__gallery-container--right")) {
                const ratio = $("#gallery-main").data("ratio");
                const width = $("#gallery-main").width();
                const height = width / ratio;
                $("#gallery").height(height);
                thumbsDirection = 'vertical';
                thumbsSlidesPerView = 'auto';
            }

            const initNav = (swiper, el) => {
                el.on(
                    "click",
                    ".prodigy-product__gallery-nav-prev",
                    function () {
                        if (swiper.isBeginning) {
                            swiper.slideTo(swiper.slides.length - 1);
                        } else {
                            swiper.slidePrev();
                        }
                    }
                )
                el.on(
                    "click",
                    ".prodigy-product__gallery-nav-next",
                    function () {
                        if (swiper.isEnd) {
                            swiper.slideTo(0);
                        } else {
                            swiper.slideNext();
                        }
                    }
                )
            }

            this.swiperThumbs = new Swiper(
                "#gallery-thumbs",
                {
                    direction: thumbsDirection,
                    slidesPerView: thumbsSlidesPerView,
                    spaceBetween: thumbsSpaceBetween,
                    speed: 500,
                    on: {
                        init: function (swiper) {
                            if (thumbsDirection === 'horizontal') {
                                const slides = $("#gallery-thumbs .swiper-slide");
                                if (slides.length > thumbsSlidesPerView) {
                                    $("#gallery-thumbs .prodigy-product__gallery-nav").show();
                                    initNav(swiper, $("#gallery-thumbs"));
                                }
                            } else if (thumbsDirection === 'vertical') {
                                let slidesHeight = 0;
                                let mainHeight = $("#gallery-main").outerHeight();
                                swiper.slides.forEach(
                                    slide => {
                                        slidesHeight += $(slide).outerHeight();
                                    }
                                );
                                if (slidesHeight > mainHeight) {
                                    $("#gallery-thumbs .prodigy-product__gallery-nav").show();
                                    initNav(swiper, $("#gallery-thumbs"));
                                }
                            }
                        }
                    }
                }
            );

            this.swiperMain = new Swiper(
                "#gallery-main",
                {
                    speed: 500,
                    pagination: {
                        el: ".prodigy-product__gallery-count",
                        type: "fraction",
                    },
                    thumbs: {
                        swiper: $("#gallery-thumbs").length ? this.swiperThumbs : null,
                    },
                    on: {
                        init: function (swiper) {
                            const slides = $("#gallery-main .swiper-slide");
                            if (slides.length > 1) {
                                $("#gallery-main .prodigy-product__gallery-nav").show();
                                initNav(swiper, $("#gallery-main"));
                            }
                        }
                    }
                }
            );

            if (typeof code_happened === 'undefined' || window.code_happened == false) {
                window.code_happened = true;

                $(document).on(
                    "click",
                    ".icon-fullscreen-js",
                    this.open_photo_swipe.bind(this)
                );
            }
        },

        get_gallery_images: function () {
            const slides = $("#gallery-main .prodigy-product__gallery-img svg");
            let items = [];

            if (slides.length) {
                slides.each(function (i, el) {
                    // Use the outerHTML of the SVG
                    const svgOuterHTML = el.outerHTML;

                    // Create a PhotoSwipe item object
                    const item = {
                        html: svgOuterHTML, // Use `html` to display SVG as content
                        w: 800, // Default width
                        h: 1000 // Default height
                    };

                    items.push(item);
                });
            }

            return items;
        },

        open_photo_swipe: function (e) {
            e.preventDefault();

            var pswpElement = $(".pswp")[0],
                items = this.get_gallery_images(),
                index = $("#gallery-main .swiper-slide-active").index();

            var options = $.extend(
                {
                    index: index,
                    addCaptionHTMLFn: function (item, captionEl) {
                        if (item.html) {
                            captionEl.children[0].innerHTML = item.title || '';
                            return true;
                        }
                        return false;
                    }
                },
                {}
            );

            // Initializes and opens PhotoSwipe.
            var photoswipe = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            photoswipe.init();
        },

        set_bulk: function () {
            let self = this;
            $(document).on('enable-multiple-quantity', function (e, context) {
                let bulk_attr = $(context).data('attribute');
                if (typeof bulk_attr === "undefined") {
                    bulk_attr = $('.bulk-container-js:visible').data('attribute');
                }
                let bulk_options = self.get_bulk_options(bulk_attr);
                self.set_variant_modifier(bulk_attr, bulk_options);

                if (product_logo_management_object.is_logo() && !prodigyProductBulk.is_active_logo_bulk) {
                    product_logo_management_object.set_logos();
                }

                if (
                    product_logo_management_object.is_logo() &&
                    product_logo_management_object.logo_attribute === bulk_attr &&
                    prodigyProductBulk.is_active_logo_bulk
                ) {
                    product_logo_management_object.update_locations_availability(bulk_attr);
                    product_logo_management_object.set_bulk_logo_option_validate(bulk_attr, bulk_options);
                    product_logo_management_object.bulk_logo_validate(bulk_attr, bulk_options);
                    product_logo_management_object.bulk_locations_validate();

                    prodigyProductBulk.set_bulk_data();
                }
            });
        },


        get_bulk_options: function (bulk_attr) {
            let self = this;
            let $container = $(".bulk-container-" + bulk_attr + "-js");
            $(self.disable_bulk_button_element).attr('data-value', $container.data('slug'));
            let modifierOptions = [];
            if (product_logo_management_object.is_logo() && prodigyProductBulk.is_active_logo_bulk) {
                let $logo_bulk_container = $('.bulk-container-' + product_logo_management_object.logo_attribute + '-js');
                if (typeof bulk_attr !== "undefined") {
                    $logo_bulk_container.each(function (e) {
                            $(this).find(prodigyProductBulk.input_bulk_quantity_element).each(function (e) {
                                let name = jQuery.trim($(this).data('option'));
                                let id = $(this).data('option-id');
                                modifierOptions.push({id: id, name: name});
                            });
                        }
                    );
                } else {
                    let $selected_color = $('.attribute_values_js[data-slug="color"] option:selected');
                    if ($selected_color.length > 0) {
                        let name = $selected_color.data('slug');
                        let id = $selected_color.data('option-id');
                        modifierOptions.push({id: id, name: name});
                    }
                }
            }

            return modifierOptions;
        },


        set_variant_modifier: function (attribute, modifierOptions = []) {
            let self = this;
            if (modifierOptions.length === 0) {
                $('.bulk-container-' + attribute + '-js').each(function (e) {
                    $(this).find(prodigyProductBulk.input_bulk_quantity_element).each(function (e) {
                        let name = jQuery.trim($(this).data('option'));
                        let id = $(this).data('option-id');
                        modifierOptions.push({id: id, name: name});
                    });
                });
            }

            if (self.is_variants()) {
                let attributes = self.get_attributes_for_query();
                if (Object.keys(attributes.attribute).length === 1 && $('.bulk-container-js').length === 1) {
                    attributes.attribute = [];
                }

                if (Object.keys(self.clear_selected_attributes(attributes.attribute)).length > 1) {
                    for (const [key, value] of Object.entries(attributes.attribute)) {
                        let selected_value = $(self.disable_bulk_button_element).data('value');
                        if (value === selected_value) {
                            delete attributes.attribute[key];
                        }
                    }
                }
                prodigyProductBulk.get_bulk_variant_data(attributes.attribute, modifierOptions);
            }
        },

        clear_selected_attributes: function (values) {
            $.each(values, function (key, val) {
                if ('Choose an option' === val) {
                    delete values[key];
                }
            });

            return values;
        },

        set_subscription_id: function () {
            this.subscription_id = $('.subscription_id').val();
        },

        set_elementor_options: function () {
            let is_show_regular_price = $('#regular_price_state_option').val();

            if (is_show_regular_price !== 'yes') {
                $('.regular-price-container').remove();
            } else {
                $('.regular-price-container').show();
            }
            this.set_subscriptions();
            if (this.is_bulk()) {
                this.open_bulk_option();
            }
        },

        open_bulk_option: function () {
            let i = 0;
            let is_show_certain_bulk_block = $('#is_show_certain_bulk_block').val();
            let number_certain_bulk_block = $('#number_certain_bulk_block').val();
            $('.bulk-container-js').each(function () {
                if (is_show_certain_bulk_block && number_certain_bulk_block == i) {
                    prodigyProductBulk.open_bulk_options_mode($(this));
                }
                i++;
            });
        },

        format_subscription_price: function (price) {
            if (this.is_subscriptions()) {
                if (typeof parse_price(price) === 'undefined') {
                    price = $('.sale-subscription-price-js').text();
                }

                let sale_price = $('.subscription-sale_price-js').val();
                let one_time_price = $('.prodigy-subscriptions-tab__item-price').find('.sale-price').text();
                $('.subscriptions-price-currency-js').show();

                if (parse_price(price) !== parse_price(sale_price)) {
                    $('.subscriptions-regular-price-js').text(prodigy_price_format(parse_price(price)));
                }

                $(this.product_default_info_price_element).text('$' + prodigy_price_format(parse_price(sale_price)));
                $('.prodigy-subscriptions-tab-js').trigger('click');

                if (parseFloat(one_time_price) !== parseFloat(price)) {
                    $('.subscriptions-one-time-price-js').text('$' + prodigy_price_format(parse_price(price)));

                    let one_time_sale_price = $('.prodigy-product-list__item-price-js').text();
                    if (parse_price(one_time_sale_price) !== undefined) {
                        $('.subscriptions-one-time-price-js').text(one_time_sale_price);
                    }
                } else {
                    $('.subscriptions-one-time-price-js').parent().hide();
                }
            }
        },

        is_need_replace_subscription_item: function (subscription_id) {
            let self = this;
            let remote_product_id;
            let attribute_values_js = $(".attribute_values_js");

            // if isset variants
            if (attribute_values_js.length > 0) {
                remote_product_id = $(self.add_to_cart_button_element).attr("data-remote-id");
            } else {
                if (typeof self.remote_product !== 'undefined') {
                    remote_product_id = self.remote_product.remote_master_id_variant;
                }
            }

            if (typeof remote_product_id !== "undefined") {
                let post_data = {
                    action: "prodigy-is-replace-subscription-item",
                    remote_product_id: remote_product_id,
                    one_time_order: self.is_one_time_order,
                };

                if (!self.is_one_time_order && subscription_id && typeof subscription_id !== 'undefined') {
                    self.subscription_id = subscription_id;
                    post_data.subscription_id = subscription_id;
                }

                $.ajax(
                    {
                        type: "post",
                        data: post_data,
                        dataType: "json",
                        url: ajax_url,
                        success: function (data) {
                            if (data !== null) {
                                self.is_show_subscription_popup = data.show_subscription_popup;
                            }
                        }
                    }
                );
            }
        },

        is_user_personalization_validate: function () {
            let result = true;
            $(this.prodigy_personalization_input_element).each(function () {
                if ($(this).val().trim() === '' && $(this).data('required') !== "") {
                    $(this).closest('.prodigy-personalization__label-js').addClass('prodigy-personalization__field-has-error');
                    result = false;
                }
            });

            return result;
        },

        delete_personalization_errors: function () {
            $('.prodigy-personalization__label-js').each(function () {
                $(this).removeClass('prodigy-personalization__field-has-error');
            });
        },

        get_personalization_data: function () {
            let myObj = [];

            $(this.prodigy_personalization_input_element).each(function () {
                let obj = {
                    personalization_id: $(this).data('id'),
                    personalization_field_id: $(this).data('field-id'),
                    label: $(this).attr('name'),
                    value: $(this).val(),
                };
                myObj.push(obj);
            });

            return myObj;
        },

        add_item_to_cart: function () {
            let self = this;
            $(document)
                .off("click", "button.add-to-cart-js, button.replace-subscription-condition-js")
                .on("click", "button.add-to-cart-js, button.replace-subscription-condition-js",
                    function (e) {
                        if (!self.validate_options() && !self.is_bulk_opened()) {
                            return;
                        }

                        if (!self.is_user_personalization_validate()) {
                            return;
                        } else {
                            self.delete_personalization_errors();
                        }

                        let current_button = $(this).attr('data-name');

                        if (current_button === 'replace-subscription-condition-js') {
                            $('#add_item_Modal').modal('hide');
                            self.is_show_subscription_popup = false;
                            self.is_subscription_replaced = true;
                        } else {
                            self.is_subscription_replaced = false;
                        }

                        if (self.is_show_subscription_popup) {
                            $('#add_item_Modal').modal('show');
                            self.is_show_subscription_popup = false;
                        } else {
                            self.set_analytic_add_item_to_cart();
                            let form_count_products = $(self.product_counter_input_element).val();
                            if (self.is_validate_options()) {
                                if ((self.is_variants() || product_logo_management_object.is_logo())) {
                                    if (self.is_bulk_opened()) {
                                        let variants = self.bulk_variants_info;
                                        if (prodigyProductBulk.has_bulk_color_attribute()) {
                                            variants = product_logo_management_object.get_logo_options_for_bulk(self.bulk_variants_info);
                                        }
                                        self.add_to_cart(
                                            form_count_products,
                                            variants,
                                            prodigyProductBulk.bulkVariants,
                                            self.get_personalization_data(),
                                            null,
                                            null,
                                            false,
                                            true
                                        );
                                    } else {
                                        let variant = product_logo_management_object.get_logo_options_for_bulk(self.variant);
                                        self.add_to_cart(
                                            form_count_products,
                                            variant,
                                            self.get_attributes_for_query(),
                                            self.get_personalization_data(),
                                            self.get_current_product_price(),
                                            self.subscription_id,
                                            self.is_subscription_replaced,
                                            false
                                        );
                                    }
                                } else {
                                    self.add_to_cart(
                                        form_count_products,
                                        self.variant,
                                        self.get_attributes_for_query(),
                                        self.get_personalization_data(),
                                        self.get_current_product_price(),
                                        self.subscription_id,
                                        self.is_subscription_replaced,
                                        false
                                    );
                                }
                            }
                        }

                    }
                );
        },

        get_quantity_of_products: function () {
            let self = this;
            let products_quantity = 0;

            if (prodigyProductBulk.is_active_logo_bulk) {
                $(this.bulk_container_element).each(function (e) {
                    let is_visible = $(this).is(':visible');
                    if (is_visible) {
                        $(this).find(self.input_bulk_quantity_element).each(function (e) {
                            let bulk_input_value = parseInt($(this).val());
                            if (!isNaN(bulk_input_value)) {
                                products_quantity += bulk_input_value;
                            }
                        });
                    }
                });
            } else {
                products_quantity = $(self.product_counter_input_element).val();
            }

            return products_quantity;
        },

        set_subscriptions: function () {
            var self = this;
            var sale_price = 0;

            $(document).on('change', '.subscription-radio-js', function () {
                    if ($(this).is(':checked')) {
                        sale_price = $(this).prev().prev().prev().prev().val();
                        var sale_price_rounded = parseFloat(sale_price) < 0 ? 0 : parseFloat(sale_price);
                        self.subscription_price = sale_price;
                        $('.sale-subscription-price-js').text(prodigy_price_format(sale_price_rounded));
                        self.subscription_id = $(this).prev().prev().prev().val();
                        self.is_need_replace_subscription_item(self.subscription_id);
                        self.set_subscription_additional_price(sale_price, $(this));

                        let price = $('.regular-price').text();
                        if (price === '') {
                            price = prodigy_price_format(parse_price($('.sale-price').text()));
                        }

                        let price_container = $(this).closest('.prodigy-subscriptions-tab').find('.prodigy-subscriptions-tab__item-sale');
                        if (parse_price(self.subscription_price) !== parse_price(price)) {
                            price_container.show();
                            $('.subscriptions-regular-price-js').text(prodigy_price_format(parse_price(price))).show();
                        } else {
                            price_container.hide();
                        }
                    }
                }
            );

            $(document).on(
                'click',
                'button.prodigy-close-button, button.close-subscription-popup-js',
                function () {
                    $('#add_item_Modal').modal('hide');
                    self.is_show_subscription_popup = true;
                }
            );

            $(document).on(
                'click',
                '.prodigy-subscriptions-tab-js',
                function () {
                    self.set_subscription_options($(this));
                    self.activate_subscription_block($(this));
                    let is_conditions = $(this).next().find('.prodigy-subscription-period-js');

                    if (is_conditions.length > 0) {
                        $('.subscription-radio-js').each(
                            function () {
                                if ($(this).is(':checked')) {
                                    $('.subscription-radio-js').removeAttr('disabled');
                                    sale_price = parseFloat($('.sale-subscription-price-js').text().trim());
                                    self.subscription_price = parseFloat(sale_price) < 0 ? 0 : parseFloat(sale_price);
                                    self.subscription_id = $(this).prev().prev().prev().val();
                                    self.is_need_replace_subscription_item(self.subscription_id);
                                    self.set_subscription_additional_price(sale_price, $(this));
                                }
                            }
                        );
                    } else {
                        self.is_need_replace_subscription_item();
                        let price = $(this).next().find('.prodigy-subscriptions-tab__item-price').text();
                        $(self.product_default_info_price_element).text(price);
                    }
                }
            );
        },

        get_attributes_for_query: function () {
            let attribute_values_js = $('.attribute_values_js:not(.ignored)');
            let attribute_swatch = $('.prodigy-product__swatch-block-js:not(.ignored)');
            let attributes = {attribute: {}, item: {}};
            attribute_values_js.each(
                function (key) {
                    let $option = $(this).find("option:selected");
                    attributes["attribute"][key] = $option.data('slug');
                    attributes["item"][key] = $option.text();
                }
            );

            attribute_swatch.find('.prodigy-product__swatch-js').each(
                function (key) {
                    if ($(this).is(':checked')) {
                        attributes["attribute"][key] = $(this).data('slug');
                        attributes["item"][key] = $(this).val();
                    }
                }
            );

            return attributes;
        },

        set_subscription_options: function (container) {
            let self = this;
            self.set_subscription_price(container);
            if (container.hasClass("active")) {
                if (container.attr('aria-controls') === 'nav-home') {
                    self.subscription_price = container.find('.sale-price').text().trim();
                    self.is_one_time_order = true;
                } else {
                    self.subscription_price = $('.sale-subscription-price-js').text().trim();
                    self.is_one_time_order = false;
                }
            }
        },

        load_subscription_price: function () {
            let self = this;
            $('.prodigy-subscriptions-tab-js').each(
                function () {
                    self.set_subscription_options($(this));
                }
            );
        },

        set_subscription_additional_price: function (price, container) {
            let format_price_string = '$' + prodigy_price_format(price);
            let condition_string = container.parent().find('.subscription-condition-js').val();
            $(this.product_default_info_price_element).text(format_price_string + ' (' + condition_string + ')');
        },

        activate_subscription_block: function (container) {
            $('.prodigy-subscriptions-radio-js').prop('checked', false);
            $('.prodigy-subscriptions-tab-js').removeClass('active');
            $(container).find('.prodigy-subscriptions-radio-js').prop('checked', true);
            container.addClass('active');
            $('.subscription-radio-js').prop(
                'disabled',
                function (i, v) {
                    return !v;
                }
            );
        },

        set_subscription_price: function (container) {
            let subscription_price = $('.prodigy-subscriptions-wrap-price-js').text();
            $('.prodigy-additional-info-price-js').text(subscription_price).show();
        },

        get_current_product_price: function () {
            var self = this;
            var price = 0;
            var price_str = $(document).find(".sale-price").text().trim();

            if (self.is_subscriptions() && !self.is_one_time_order) {
                price = parseFloat(self.subscription_price);
            }

            if (self.is_one_time_order && price_str !== '') {
                price = prodigy_price_format(price_str).replace(/\,/g, '');
            }

            return price;
        },

        is_bulk: function () {
            return $(this.enable_bulk_element).length;
        },

        is_bulk_opened: function () {
            return $('.prodigy-bulk__wrap').is(":visible");
        },

        add_to_cart: function (
            number_of_product,
            variants,
            attributes_item,
            personalization = [],
            price = null,
            subscription_id = null,
            is_subscription_replaced = false,
            is_bulk = false,
            logo_ids = []
        ) {
            let self = this;
            let post_data = {
                action: "prodigy-add-remote-cart",
                variants: variants,
                count: number_of_product,
                price: price,
                attributes: attributes_item,
                is_subscription_replaced: is_subscription_replaced,
                is_bulk: is_bulk,
                logos_ids: logo_ids,
                personalization: personalization,
                nonce: settings.nonce
            };

            self.show_cart_button_loader();

            if (!self.is_one_time_order) {
                post_data.subscription_id = subscription_id;
            }
            clearTimeout(self.timeoutAddToCartId);
            self.timeoutAddToCartId = setTimeout(
                function () {
                    $.ajax(
                        {
                            type: "post",
                            data: post_data,
                            dataType: "json",
                            url: ajax_url,
                            error: function (data) {
                                if (self.is_tiered_price && data.error_code && data.error_code === 422) {
                                    self.show_tiered_price_modal(data);
                                    return;
                                }

                                if (window.prodigy_cart_widget !== undefined) {
                                    window.prodigy_cart_widget.cart_modal_trigger(true);
                                }
                                self.show_error(data.responseJSON.data);
                            },
                            success: function (data) {
                                if (self.is_bulk_opened()) {
                                    prodigyProductBulk.reset_bulk_inputs();
                                }

                                if (window.prodigy_cart_widget !== undefined) {
                                    window.prodigy_cart_widget.cart_modal_trigger(false);
                                }

                                if (
                                    (self.is_tiered_price && typeof data.error_code === "undefined") ||
                                    !self.is_tiered_price
                                ) {
                                    self.cart_slide_open();
                                    if (!self.is_tiered_price) {
                                        $(self.product_counter_input_element).val(1);
                                    }
                                    self.show_add_to_cart_message();
                                    self.show_cart_message();
                                }

                                if (self.is_tiered_price) {
                                    self.get_tiered_prices_range_ajax();
                                }

                                self.hide_cart_button_loader();
                                // redirect to cart page
                                if ($(".cart-redirect-js").data("cart-redirect") === "redirect_to_cart") {
                                    var dinamic_cart_url = $('.pg-cart-url-js').data('attr');
                                    window.location.replace(dinamic_cart_url);
                                }
                            }
                        }
                    );
                },
                500
            );
        },

        show_cart_button_loader: function () {
            $(this.add_to_cart_button_element).prop("disabled", true);
        },

        hide_cart_button_loader: function () {
            $(this.add_to_cart_button_element).prop("disabled", false);
        },


        show_tiered_price_modal: function (data) {
            let cart_slider = $('.prodigy-cart-slide-js');
            cart_slider.removeClass('prodigy-cart-slide--open');
            $('body').removeClass('overflow-hidden');
            if (typeof data.message !== undefined) {
                $('.tiered-price-message-js').text(data.message);
                $('#minorderQTY').modal('show');
            }
        },

        cart_slide_open: function () {
            let cart_slider = $('.prodigy-cart-slide-js');
            let slider = cart_slider.data('auto-open');
            if (slider === 'yes' || slider) {
                cart_slider.toggleClass('prodigy-cart-slide--open');
                $('body').toggleClass('overflow-hidden');
                setTimeout(
                    function () {
                        cart_slider.removeClass('prodigy-cart-slide--open');
                        $('body').removeClass('overflow-hidden');
                    },
                    10000
                );
            }
        },

        set_checked_swatch: function () {
            let self = this;
            self.selectedVariant = [];
            let options = {};
            $(self.prodigy_product_swatch_element).each(function () {
                let swatch_block = $(this).closest(self.prodigy_product_swatch_block_element);
                if ($(this).is(':checked') && !$(swatch_block).hasClass('ignored')) {
                    let slug = $(this).data('slug');
                    let attribute = swatch_block.data('attribute');
                    $(this).closest('.swatch-container-js').find('.swatch-attribute-name-js').html("&nbsp;" + $(this).val());
                    self.selectedVariant.push(slug);

                    if (
                        $(this).data('attribute') === product_logo_management_object.logo_attribute &&
                        product_logo_management_object.is_logo()
                    ) {
                        options[0] = {name: slug};
                        self.set_gallery(options, attribute);
                        self.set_logo();
                    }

                    if (!product_logo_management_object.is_logo()) {
                        options[0] = {name: slug};
                        self.set_gallery(options, attribute);
                        if (!product_logo_management_object.is_logo() && ($(this).data('attribute') === product_logo_management_object.logo_attribute)) {
                            self.set_logo();
                        }
                    }

                }
            });
        },

        set_logo: function () {
            product_logo_management_object.update_forms_visibility();
            product_logo_management_object.init_logos_locations_form();
            if (product_logo_management_object.is_logo_swatches()) {
                product_logo_management_object.set_logos_swatches();
            } else {
                product_logo_management_object.set_logos();
            }
        },

        change_swatch_value: function () {
            let self = this;
            $(document).on('change', self.prodigy_product_swatch_element, function () {
                self.set_checked_swatch();
                if (!prodigyProductBulk.is_bulk_enabled()) {
                    self.set_variant_data();
                }

                if (prodigyProductBulk.is_active_bulk) {
                    prodigyProductBulk.activate_bulk_processes();
                }

                self.show_available_variants();

                if (self.is_bulk()) {
                    $(this).parent().parent().closest('.prodigy-product__attr-item--no-select').find(self.enable_bulk_element).attr('data-value', $(this).data('slug'));
                }
            });
        },


        get_active_swatches: function () {
            let active_options = [];
            $('.prodigy-product__swatch-js:checked').each(function () {
                active_options.push($(this).data('slug'));
            });

            return active_options;
        },

        get_active_swatches_attributes: function () {
            let self = this;
            let active_attributes = [];
            $('.prodigy-product__swatch-js:checked').each(function () {
                active_attributes.push($(this).closest(self.prodigy_product_swatch_block_element).data('attribute'));
            });

            return active_attributes;
        },


        set_variant_data() {
            let logo_id = false;
            this.set_checked_swatch();
            if (this.is_variants() && this.is_validate_options()) {
                let number_of_items = parseInt($(this.product_counter_input_element).val());

                if (product_logo_management_object.is_logo()) {
                    logo_id = product_logo_management_object.get_logo_id();
                }
                this.get_variant_data(this.get_selected_variant(), number_of_items, logo_id);
            }
        },

        get_selected_variant() {
            let self = this;
            let selectedVariant = [];
            if ($(self.prodigy_product_swatch_element).length > 0) {
                $(self.prodigy_product_swatch_element).each(function () {
                    let swatch_block = $(this).closest(self.prodigy_product_swatch_block_element);
                    if ($(this).is(':checked') && !$(swatch_block).hasClass('ignored')) {
                        let slug = $(this).data('slug');
                        selectedVariant.push(slug);
                    }
                });
            } else {
                $('.attribute_values_js').each(function () {
                    let current_slug = $(this).find('option:selected').data('slug');

                    if (!$(this).hasClass('ignored') && $(this).parent().is(':visible')) {
                        selectedVariant.push(current_slug);
                    }
                })
            }
            return selectedVariant;
        },

        set_active_bulk_attribute_name: function () {
            let self = this;
            $(prodigyProductBulk.bulk_container_element).each(function () {
                    if ($(this).is(":visible")) {
                        self.active_bulk_attribute_name = $(this).data('attribute');
                    }
                }
            );
        },

        set_variant_dropdown: function () {
            let is_variant_gallery_prev = this.is_variant_gallery;
            this.selectedVariant = [];
            this.is_variant_gallery = false;
            this.set_attribute_value_options();
            if (
                !this.is_bulk() &&
                this.is_variant_gallery === false &&
                is_variant_gallery_prev !== this.is_variant_gallery) {
                this.restore_default_image_gallery();
            }

            this.selectedVariant = [...new Set(this.selectedVariant)];
        },

        set_attribute_value_options: function () {
            let self = this;
            let $option = false;
            let options_list = {};
            $('.attribute_values_js').each(function () {
                    $option = $(this).find("option:selected");
                    if (
                        typeof $option.data('slug') !== "undefined" &&
                        typeof $option.data('attribute') !== "undefined"
                    ) {

                        if (
                            $(this).data('attribute') === product_logo_management_object.logo_attribute &&
                            product_logo_management_object.is_logo()
                        ) {
                            options_list[0] = {name: $option.data('slug')};
                            self.set_gallery(options_list, $option.data('attribute'));
                            self.set_logo();
                        }

                        if (!product_logo_management_object.is_logo()) {
                            options_list[0] = {name: $option.data('slug')};
                            self.set_gallery(options_list, $option.data('attribute'));
                            if (!product_logo_management_object.is_logo() && ($(this).data('attribute') === product_logo_management_object.logo_attribute)) {
                                self.set_logo();
                            }
                        }
                    }

                    self.selected_attributes[$(this).data('slug')] = $option.data('slug');

                    if (!$(this).hasClass('ignored') && $option.data('slug') !== '') {
                        self.selectedVariant.push($option.data('slug'));
                        if (self.is_bulk()) {
                            $(this).parent().find(self.enable_bulk_element).attr('data-slug', $option.data('slug'));
                        }
                    }
                }
            );
        },

        prepare_main_slider_slide: function (current_image_id, image_url, view_box = null, width = null, height = null, large_img = null) {
            let clone = $(this.main_slider_template).contents().clone();
            let svg = clone.find('.main-gallery-image-js').parent();
            let img = clone.find('img');

            if (width > 0) {
                img.attr('data-large_image_width', width);
            }
            if (height > 0) {
                img.attr('data-large_image_height', height);
            }
            if (large_img) {
                img.attr('data-large_image', large_img);
            }

            clone.find('.main-gallery-image-js').attr('href', image_url);
            clone.find('.main-gallery-image-js').attr('data-image-id', current_image_id);

            if (view_box) {
                svg.attr('viewBox', view_box);
            }
            return clone;
        },

        prepare_thumbnail_slider_slide: function (current_image_id, image_url, view_box) {
            let clone = $(this.thumb_slider_template).contents().clone();
            clone.find('image.thumb-gallery-image-js').attr('href', image_url);
            clone.find('image.thumb-gallery-image-js').attr('data-image-id', current_image_id);
            clone.find('svg').attr('viewBox', view_box);

            return clone;
        },

        set_gallery: function (slugs, attribute) {
            this.is_variant_gallery = true;
            let option_attributes = [];
            let option_images = '';
            let product_options = JSON.parse($('#product-options-data-js').val());
            $.each(product_options, function (i) {
                for (k in slugs) {
                    if (attribute === i) {
                        option_attributes.push(product_options[i][slugs[k].name]);
                    }
                }
            });

            let images = [];
            for (let k in option_attributes) {
                if (!option_attributes[k] || typeof option_attributes[k].images === 'undefined') {
                    return false;
                }
                option_attributes[k].images.forEach(image => images.push(image));
            }

            if (images.length > 0) {
                this.swiperMain.removeAllSlides();

                if (this.is_gallery_thumbnails()) {
                    this.swiperThumbs.removeAllSlides();
                }

                for (let i in images) {
                    const attributes = images[i].attributes;
                    const image_url = attributes['cropped-url'];
                    const thumbnail_url = attributes['cropped-url'];
                    let width = 0;
                    let height = 0;
                    let view_box = '0 0 800 1000';

                    if (typeof attributes['cropping-params'] !== undefined && attributes['cropping-params'] !== null) {
                        width = typeof attributes['cropping-params']['w'] !== undefined ? parseInt(attributes['cropping-params']['w']) : 0;
                        height = typeof attributes['cropping-params']['h'] !== undefined ? parseInt(attributes['cropping-params']['h']) : 0;
                        view_box = width > 0 && height > 0 ? '0 0 ' + width + ' ' + height : '0 0 800 1000';
                    }

                    const large_img = attributes.versions['large_retina'] ? attributes.versions['large_retina'] : '';

                    let current_image_id = images[i].id;
                    this.swiperMain.appendSlide(this.prepare_main_slider_slide(
                        current_image_id,
                        image_url,
                        view_box,
                        width,
                        height,
                        large_img
                    ));
                    if (this.is_gallery_thumbnails()) {
                        this.swiperThumbs.appendSlide(this.prepare_thumbnail_slider_slide(current_image_id, thumbnail_url, view_box));
                    }
                }
            } else {
                this.restore_default_image_gallery();
            }

            if (option_attributes.images && typeof option_attributes[k].images[0] !== "undefined") {
                option_images = option_attributes[k].images[0].attributes;
            }
            $('.swiper-slide-active').find('.main-gallery-image-js').attr('href', option_images["cropped-url"]);
        },

        is_gallery_thumbnails: function () {
            return $('#gallery-thumbs').length > 0;
        },

        restore_default_image_gallery: function () {
            let images = $('#gallery-main').data('images');
            if (images.length !== 0) {
                this.swiperMain.removeAllSlides();
                this.swiperThumbs.removeAllSlides();
                for (i in images) {
                    const image_url = images[i]['cropped-url'];
                    const thumbnail_url = images[i].versions['thumbnails'];
                    let view_box = '';

                    if (typeof images[i]['cropping-params'] !== 'undefined' && images[i]['cropping-params'] !== null) {
                        let width = typeof images[i]['cropping-params']['w'] !== 'undefined' ? images[i]['cropping-params']['w'] : 0;
                        let height = images[i]['cropping-params']['h'] ? images[i]['cropping-params']['h'] : 0;
                        view_box = height && width ? '0 0 ' + width + ' ' + height : '';
                    }

                    this.swiperMain.appendSlide(this.prepare_main_slider_slide(images[i].id, image_url, view_box));
                    this.swiperThumbs.appendSlide(this.prepare_thumbnail_slider_slide(images[i].id, thumbnail_url, view_box));
                }
            }
        },

        choose_variant_dropdown: function () {
            let self = this;
            let $attribute_values = $('.attribute_values_js');
            if (!prodigyProductBulk.is_active_bulk) {
                this.show_available_variants();
            }
            this.set_variant_dropdown();

            if (this.get_selected_variant().length === $attribute_values.length) {
                this.isVariantSelected = true;
            }
            if (this.isVariantSelected && this.is_validate_options()) {
                self.show_cart_button_loader();
                if (this.is_variants()) {
                    let number_of_items = parseInt($(self.product_counter_input_element).val());
                    if (this.is_bulk_opened()) {
                        prodigyProductBulk.set_bulk_data();
                    } else {
                        if (this.is_validate_options() && !self.is_bulk_opened()) {
                            let logo_id = product_logo_management_object.get_logo_id();
                            this.get_variant_data(this.get_selected_variant(), number_of_items, logo_id);
                        }
                    }
                }
            } else {
                this.is_one_time_order = true;
                this.show_master_variant_info();

                if (typeof self.remote_product.remote_master_variant_info !== "undefined") {
                    let dimension_attrs = this.remote_product.remote_master_variant_info.dimension.attributes;
                    this.set_shipping_data_variants(
                        this.remote_product.remote_main_sku,
                        dimension_attrs['weight-value'] + dimension_attrs['weight-unit'],
                        dimension_attrs['depth-value']
                        + ' x ' + dimension_attrs['width-value']
                        + ' x ' + dimension_attrs['height-value']
                        + dimension_attrs['size-unit']
                    );
                }
            }
        },


        get_variant_data: function (
            variant,
            number_of_items = null,
            logo_id = false,
            selector = null,
            is_bulk = false,
            bulk_attribute = false
        ) {
            let self = this;
            let post_data = {
                action: "prodigy-public-get-variant-data",
                post_id: $("#product_id").val(),
                variants: variant,
                options: this.get_options(),
                number_of_items: number_of_items,
                is_bulk: is_bulk,
                bulk_attribute: bulk_attribute,
                logo_id: logo_id,
                is_personalization: this.is_personalization(),
                location: window.location.href,
                nonce: settings.nonce
            };

            clearTimeout(self.timeoutVariantsDataId);
            $(self.add_to_cart_button_element).prop("disabled", true);
            $(self.add_to_cart_button_element).removeAttr('data');
            self.timeoutVariantsDataId = setTimeout(
                function () {
                    $.ajax(
                        {
                            type: "post",
                            data: post_data,
                            dataType: "json",
                            url: ajax_url,
                            error: function (xhr, status, error) {
                                $(self.add_to_cart_button_element).prop("disabled", true);
                                $(self.add_to_cart_button_element).attr('data', 'loader');
                            },
                            success: function (response) {
                                if (response.data.result && typeof response.data.result[0] !== "undefined") {
                                    self.variant = response.data.result[0];
                                    $('#variant-data-js').attr('data-variant', JSON.stringify(response.data.result[0]));
                                }
                                if (typeof self.variant === "undefined") {
                                    return;
                                }
                                $(self.add_to_cart_button_element).removeAttr('data');
                                if (self.is_bulk_opened()) {
                                    $(self.add_to_cart_button_element).removeAttr("disabled");
                                    prodigyProductBulk.update_bulk_price(response.data);
                                    self.update_bulk_info(response.data.result);
                                    $('#variant-data-js').attr('data-bulk-variants', JSON.stringify(response.data));
                                }


                                if (typeof self.variant !== undefined && self.variant.subscriptions) {
                                    $('#subscriptions_block').html(self.variant.subscriptions);
                                }

                                self.set_variants_data(self.variant);
                                self.set_product_data_for_cart(self.variant);

                                if (!self.is_subscriptions()) {
                                    self.is_one_time_order = true;
                                }

                                self.set_shipping_data(self.variant);
                                self.disable_add_to_cart_button_loader();

                                if (!self.is_bulk_opened() && !self.is_variant_was_chosen) {
                                    self.set_tiered_prices(self.variant);
                                }
                            }
                        }
                    );
                },
                500
            );
        },

        update_bulk_info: function (data) {
            this.bulk_variants_info = data;
        },

        is_subscriptions: function () {
            return $(document).find('.prodigy-subscriptions-tab').length > 0;
        },

        disable_add_to_cart_button_loader: function () {
            $(this.add_to_cart_button_element).prop("disabled", false);
        },

        set_tiered_prices: function (product) {
            this.min_quantity = product.tiered_prices_range.min_quantity;
            if (this.is_tiered_price) {
                localStorage.setItem("min_quantity", product.tiered_prices_range.min_quantity);
                if (parseFloat(product.tiered_prices_range.min_price) !== parseFloat(product.tiered_prices_range.max_price)) {
                    let range_price_string = 'From $' + prodigy_price_format(product.tiered_prices_range.min_price) + ' to $' + prodigy_price_format(product.tiered_prices_range.max_price);
                    $('.prodigy-product__main-price').text(range_price_string);
                }

                $(this.product_counter_input_element).val(product.tiered_prices_range.min_quantity);
                $(document).find(".counter-btn-minus-js").prop("disabled", true);
            }
        },

        set_shipping_data: function (product) {
            if (typeof product.dimension !== "undefined") {
                let dimension_attrs = product.dimension.attributes;
                this.set_shipping_data_variants(
                    product.attributes.sku,
                    dimension_attrs['weight-value'] + dimension_attrs['weight-unit'],
                    dimension_attrs['depth-value']
                    + ' x ' + dimension_attrs['width-value']
                    + ' x ' + dimension_attrs['height-value']
                    + dimension_attrs['size-unit']
                );
            }
        },


        update_variants_dropdown: function () {
            let self = this;
            let variantsObj = $('div.variants-container-js');
            let variants = variantsObj.data('variants');
            if (variants !== 'undefined') {
                $('select[data-attribute]').each(
                    function () {
                        self.update_select($(this), variants, {});
                    }
                );
                let dropdownOpened = false;
                MsDropdown.make('.attribute_values_js', {
                    enableAutoFilter: false,
                    on: {
                        open: function () {
                            dropdownOpened = true;
                        },
                        change: function (data) {
                            if (dropdownOpened) {
                                self.choose_variant_dropdown();

                                if (prodigyProductBulk.is_active_bulk) {
                                    prodigyProductBulk.activate_bulk_processes();
                                }

                                self.show_available_variants();

                                dropdownOpened = false;

                                if (!product_logo_management_object.is_logo()) {
                                    return;
                                }

                                if (!prodigyProductBulk.is_active_bulk) {
                                    if (product_logo_management_object.is_logo_swatches()) {
                                        product_logo_management_object.set_logos_swatches();
                                        product_logo_management_object.update_locations_availability();
                                    } else {
                                        product_logo_management_object.set_logos();
                                        $('.prodigy-logo-tool__container.opened .prodigy-logo-values-js').each(function () {
                                            $(this).get(0).msDropdown.refresh();
                                        });
                                        product_logo_management_object.update_locations_availability();
                                    }
                                }
                            }
                        }
                    }
                });
            }
        },

        is_variants: function () {
            let attributes = $('.variants-container-js').data('attributes');
            if (attributes !== undefined)
                return Boolean(attributes.length);
        },

        update_select: function ($select, variants, selected_attributes) {
            let attributes = $('.variants-container-js').data('attributes');
            let available_attributes = {};

            for (i in variants) {
                let variant = variants[i];
                for (j in attributes) {
                    let attr_name = attributes[j];
                    if (typeof variant[attr_name] !== 'undefined') {
                        let value = Object.values(variant[attr_name])[0];
                        if (value !== undefined) {
                            if (available_attributes[attr_name] === undefined) {
                                available_attributes[attr_name] = [];
                            }
                            available_attributes[attr_name][value.name] = value;
                        }
                    }
                }
            }

            if ($select.length > 0) {
                let attr_name = $select.data('attribute');
                let default_select_option = $('#default_select_option').val();
                $select.html('<option class="attributes_default_value-js prodigy-attr__default-value" value="">' + default_select_option + '</option>');
                let orderedVariants = [];
                if (typeof available_attributes[attr_name] !== 'undefined') {
                    Object.values(available_attributes[attr_name]).sort(this.compareBySort).forEach(
                        function (variant) {
                            orderedVariants.push(variant.name);
                        }
                    );
                }

                orderedVariants.forEach(
                    function (i) {
                        let attr_value_name = available_attributes[attr_name][i].name;
                        let attr_value_slug = available_attributes[attr_name][i].slug;
                        let attr_value_id = available_attributes[attr_name][i].option_id;
                        let attr_value_logos = JSON.stringify(available_attributes[attr_name][i].logos);
                        let attr_value_attribute = available_attributes[attr_name][i].attribute;

                        let option = $('<option>').text(attr_value_name).val(attr_value_slug);
                        let dataColorProperties = '';

                        // set color like a picture
                        if (available_attributes[attr_name][i].color != undefined) {
                            const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                            svg.setAttribute("width", "100");
                            svg.setAttribute("height", "100");
                            svg.style.backgroundColor = "black";

                            const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                            rect.setAttribute("width", "100%");
                            rect.setAttribute("height", "100%");
                            rect.setAttribute("fill", available_attributes[attr_name][i].color);
                            svg.appendChild(rect);

                            const svgData = new XMLSerializer().serializeToString(svg);
                            const svgBase64 = btoa(svgData);
                            const dataUrl = 'data:image/svg+xml;base64,' + svgBase64;
                            option.attr('data-image', dataUrl);
                        }
                        if (available_attributes[attr_name][i].image !== undefined) {
                            option.attr('data-image', available_attributes[attr_name][i].image);
                        }

                        option.addClass('attached enabled');
                        if (dataColorProperties) {
                            option.attr('style', '--data-color:' + dataColorProperties);
                        }
                        option.attr('data-attribute', attr_value_attribute);
                        option.attr('data-logos', attr_value_logos);
                        option.attr('data-slug', attr_value_slug);
                        option.attr('data-option-id', attr_value_id);
                        if (
                            selected_attributes[attr_name] === attr_value_name ||
                            available_attributes[attr_name][i].default
                        ) {
                            option.attr('selected', true);
                        }
                        $select.append(option);
                    }
                );
            }
        },

        compareBySort: function (a, b) {
            return a.sort - b.sort;
        },

        scroll_for_hash: function (hash) {
            if (hash) {
                var hash = hash;

                $('html, body').animate(
                    {
                        scrollTop: $(hash).offset().top
                    },
                    1500,
                    'swing'
                );
            }
        },

        /**
         *
         * @version 2.0.0
         */
        set_analytic_add_item_to_cart: function () {
            if (settings.pg_google_track_id !== '') {
                let current_url = window.location.pathname.replace(/\/+$/, "");
                if (current_url.includes(settings.product_type)) {
                    let self = this;
                    let product = self.variant;
                    let price = product.attributes.price;
                    let sku = product.attributes.sku;
                    /**
                     * TODO check title in api
                     */
                    let title = product.attributes.sku;
                    let sale_price = product.attributes['sale-price'];
                    let remote_variant_id = product.remote_variant_id;
                    if (settings.pg_google_track_id !== '') {
                        gtag(
                            'event',
                            'add_to_cart',
                            {
                                "event_category": 'prodigy_ecommerce',
                                "items": [
                                    {
                                        "id": remote_variant_id,
                                        "name": title,
                                        // "category": product.categories,
                                        "variant": sku,
                                        "price": self.get_actual_price(price, sale_price),
                                        "quantity": parseInt($(self.product_counter_input_element).val()),
                                    }
                                ]
                            }
                        );
                    }
                }
            }
        },

        /**
         * @version 2.0.0
         */
        change_product_quantity_analytic_event: function () {
            let self = this;
            if (settings.pg_google_track_id !== "") {
                let current_url = window.location.pathname.replace(/\/+$/, "");
                if (current_url.includes(settings.product_type)) {
                    let old_quantity = parseInt($(self.product_counter_input_element).val());

                    $('.counter-btn-plus-js, .counter-btn-minus-js').on(
                        'click',
                        function () {
                            let product = self.variant;

                            let price = product.attributes.price;
                            let sku = product.attributes.sku;
                            /**
                             * TODO check title in api
                             */
                            let title = product.attributes.sku;
                            let sale_price = product.attributes['sale-price'];
                            let remote_variant_id = product.remote_variant_id;
                            if (settings.pg_google_track_id !== '') {
                                gtag(
                                    'event',
                                    'change_product_quantity',
                                    {
                                        "event_category": 'prodigy_product',
                                        "items": [
                                            {
                                                "id": remote_variant_id,
                                                "name": title,
                                                "sku": sku,
                                                "price": self.get_actual_price(price, sale_price),
                                                "new_quantity": parseInt($(self.product_counter_input_element).val()),
                                                "old_quantity": old_quantity,
                                            }
                                        ]
                                    }
                                );
                            }
                        }
                    );
                }
            }
        },

        /**
         * @version 2.0.0
         * @param data
         */
        set_view_product_analytic_event: function (data) {
            let current_url = window.location.pathname.replace(/\/+$/, "");

            if (typeof data.attributes !== "undefined") {
                let price = data.attributes.price;
                let sku = data.attributes.sku;
                /**
                 * TODO check title in api
                 */
                let title = data.attributes.sku;
                let sale_price = data.attributes['sale-price'];
                let remote_variant_id = data.remote_variant_id;

                if (typeof current_url.includes(settings.product_type)) {
                    let self = this;
                    if (settings.pg_google_track_id !== '') {
                        gtag(
                            'event',
                            'view_variant',
                            {
                                "event_category": 'prodigy_product',
                                "items": [
                                    {
                                        "id": remote_variant_id,
                                        "name": title,
                                        // "category": data.categories,
                                        "variant": sku,
                                        "price": self.get_actual_price(price, sale_price)
                                    }
                                ]
                            }
                        );
                    }
                }
            }
        },

        captcha_callback: function (val) {
            $(".recaptcha-checkbox").attr("aria-checked", true);
            this.check_enable_comment_fields();
        },

        reset_focus_to_press_enter: function () {
            let self = this;
            $(document).on(
                "keypress blur focusout",
                self.product_counter_input_element,
                function (e) {
                    self.update_counter_of_products(self, $(this));
                }
            );
        },

        update_counter_of_products: function (self, container) {
            let number_of_items = parseInt($(self.product_counter_input_element).val());
            if (
                this.is_tiered_price &&
                this.is_variants() &&
                this.is_validate_options()
            ) {
                let logo_id = product_logo_management_object.get_logo_id();
                this.get_variant_data(this.get_selected_variant(), number_of_items, logo_id);
            } else if (this.is_tiered_price && this.is_validate_options()) {
                this.get_master_variant_data(number_of_items);
            }

            if (parseInt(container.val()) > 1) {
                $(".counter-btn-minus-js").prop("disabled", false);
            }
        },

        send_captcha: function () {
            $(".submit-product-button").click(
                function (e) {
                    var response;
                    $.ajax(
                        {
                            type: "post",
                            data: $("#commentform").serialize() + "&action=google-captcha-url",
                            dataType: "json",
                            url: ajax_url,
                            async: false,
                            success: function (data) {
                                if (data.nocaptcha === "true") {
                                    response = 1;
                                } else if (data.spam === "true") {
                                    response = 1;
                                } else {
                                    response = 0;
                                }
                            }
                        }
                    );
                }
            );
        },

        send_review_for_user: function () {
            var is_admin = this.is_admin;
            $(document).on(
                'submit',
                'form#commentform',
                function (e) {
                    e.preventDefault();
                    $('#submit').addClass('prodigy-main-button--loading');
                    var form = $('form#commentform');

                    $.ajax(
                        {
                            type: 'POST',
                            url: form.attr('action'),
                            data: form.serialize(),
                            error: function (error) {
                                $('#reviewModal').modal('toggle');
                                $('#reviewModalSuccess').modal('toggle');
                                $('.prodigy-reviews-ratings__btn').hide();
                                $('.review-message-popup-js').text('Couldn\'t submit a review. Please try again later.');
                            },
                            success: function (respond_data) {
                                $('#reviewModal').modal('toggle');
                                $('.prodigy-reviews-ratings__btn').hide();
                                if (!is_admin) {
                                    $('#submit').removeClass('prodigy-main-button--loading');
                                    if (typeof respond_data !== "undefined") {
                                        $('#reviewModalSuccess').modal('toggle');
                                        $('.review-message-popup-js').text('We will post your review soon after moderation approve');
                                    }
                                }
                            }
                        }
                    );
                }
            );
        },

        show_cart_message() {
            var add_to_cart_message = $('.widget-cart-add-item-message-js');
            add_to_cart_message.show();
            add_to_cart_message.delay(5000).fadeOut('slow');
        },

        show_view_cart_btn() {
            var view_cart = $(".view-cart-js");
            view_cart.show();
            $(".prodigy-product__values").removeClass("flex-nowrap");
        },

        show_add_to_cart_message() {
            var self = this;
            $(self.add_to_cart_button_element).prop("disabled", true);
            self.show_cart_message();
            self.show_view_cart_btn();

            setTimeout(
                function () {
                    $(self.add_to_cart_button_element).prop("disabled", false);
                },
                5000
            );
        },

        show_error: function (message, type = "success") {
            let self = this;
            let add_to_cart_message = $(".widget-cart-message-error-js");
            add_to_cart_message.find("span").html(message);
            add_to_cart_message.show();
            add_to_cart_message.delay(5000).fadeOut("slow");
            if (type === "error") {
                add_to_cart_message.addClass("prodigy-cart-dropdown__error-alert");
            }
            self.hide_cart_button_loader();
        },

        disable_submit_comment: function () {
            let self = this;

            self.check_enable_comment_fields();

            $(document).on('input', "#comment", function (e) {
                    self.check_enable_comment_fields();
                }
            );

            $(document).on('input', ".comment-author-js", function (e) {
                    self.check_enable_comment_fields();
                }
            );

            $(document).on('input', ".comment-email-js", function (e) {
                    self.check_enable_comment_fields();
                }
            );

            $("body").on(
                "change",
                "#prodigy-rating",
                function (e) {
                    self.check_enable_comment_fields();
                }
            );
        },

        check_enable_comment_fields: function () {
            var comment_submit = $(".prodigy-main-button.submit-product-button");

            var rating_form = $(".comment-form-rating").length;

            if (!this.is_admin) {
                var rating_val = $("#prodigy-rating").val();
            }

            var comment_val = $("#comment").val();
            var name_val = $(".comment-author-js").val();
            var email_val = $(".comment-email-js").val();
            var captcha_val = $("#g-recaptcha-response").val();
            var captcha = $("#g-recaptcha-response");
            var is_rating_enable = $(".prodigy-comment__rating").length > 0;
            var is_email_enable = $(".comment-email-js").length > 0;
            var enable_submit = true;

            if (document.body.classList.contains("logged-in")) {
                if (this.is_admin) {
                    var enable_submit = comment_val;
                } else if (typeof rating_val !== 'undefined') {
                    var enable_submit = rating_val && comment_val;
                } else {
                    var enable_submit = comment_val;
                }
                if (captcha.length > 0 && !this.is_admin) {
                    var enable_submit = rating_val && comment_val && captcha_val;
                } else if (captcha.length > 0 && this.is_admin) {
                    var enable_submit = comment_val && captcha_val;
                }
            } else {
                if (typeof rating_val !== "undefined") {
                    var enable_submit = rating_val && comment_val && name_val && email_val;
                    if (captcha.length > 0 && !this.is_admin) {
                        var enable_submit = rating_val && comment_val && name_val && captcha_val && email_val;
                    } else if (captcha.length > 0 && this.is_admin) {
                        var enable_submit = comment_val && name_val && captcha_val && email_val;
                    } else if (captcha.length > 0 && this.is_admin && is_rating_enable) {
                        var enable_submit = comment_val && name_val && rating_val && email_val;
                    } else if (captcha.length == 0 && this.is_admin && !is_rating_enable) {
                        var enable_submit = comment_val && name_val && email_val;
                    } else if (captcha.length == 0 && !this.is_admin && !is_rating_enable && !is_email_enable) {
                        var enable_submit = comment_val && name_val;
                    } else if (captcha.length == 0 && !this.is_admin && is_rating_enable && !is_email_enable) {
                        var enable_submit = comment_val && name_val;
                    }
                } else {
                    var enable_submit = comment_val && name_val && email_val;

                    if (captcha.length > 0 && !this.is_admin) {
                        var enable_submit = comment_val && name_val && captcha_val && email_val;
                    } else if (captcha.length > 0 && this.is_admin) {
                        var enable_submit = comment_val && name_val && captcha_val && email_val;
                    } else if (captcha.length > 0 && this.is_admin && is_rating_enable) {
                        var enable_submit = comment_val && name_val && email_val;
                    } else if (captcha.length == 0 && this.is_admin && !is_rating_enable) {
                        var enable_submit = comment_val && name_val && email_val;
                    } else if (captcha.length == 0 && !this.is_admin && !is_rating_enable && !is_email_enable) {
                        var enable_submit = comment_val && name_val;
                    }
                }
            }

            if (enable_submit) {
                comment_submit.prop("disabled", false);
            } else {
                comment_submit.prop("disabled", true);
            }
        },

        set_shipping_data_variants: function (
            sku,
            weight,
            dimension
        ) {
            let prodigy_additional_weight_js = $('.prodigy-additional-weight-js');
            let prodigy_additional_dimensions_js = $('.prodigy-additional-dimensions-js');
            let product_sku_value = $('.product_sku_value');

            prodigy_additional_weight_js.text(weight)
            prodigy_additional_dimensions_js.text(dimension)
            product_sku_value.text(sku);
        },

        counter_reset: function () {
            $(this.product_counter_input_element).val(1);
        },

        set_product_counter: function () {
            let self = this;
            const counterCount = $(self.product_counter_input_element);
            counterCount.inputmask({regex: "^[1-9][0-9]*|$", rightAlign: false});

            $(document).on(
                "click",
                '.counter-btn-minus-js',
                function () {
                    let number_of_items = parseInt($(self.product_counter_input_element).val()) - 1;
                    if (!self.is_bulk_opened()) {
                        if (self.is_tiered_price && self.is_variants() && self.is_validate_options()) {
                            let logo_id = product_logo_management_object.get_logo_id();
                            self.get_variant_data(self.get_selected_variant(), number_of_items, logo_id);
                        } else if (self.is_tiered_price && self.is_validate_options()) {
                            self.get_master_variant_data(number_of_items);
                        }
                    }

                    $(self.add_to_cart_button_element).prop("disabled", false);

                    const counterCount = $(self.product_counter_input_element);
                    const minusBtn = $(".counter-btn-minus-js");
                    let counter = parseInt(counterCount.val());
                    if (counter !== self.min_quantity) {
                        counterCount.val(--counter);
                        if (counter <= self.min_quantity) {
                            minusBtn.prop("disabled", true);
                        }
                    }
                }
            );

            $(document)
                .off("click", ".counter-btn-plus-js")
                .on(
                    "click",
                    ".counter-btn-plus-js",
                    function () {
                        self.get_inventory_data();
                        let number_of_items = parseInt($(self.product_counter_input_element).val()) + 1;
                        if (!self.is_bulk_opened()) {
                            if (self.is_tiered_price && self.is_variants() && self.is_validate_options()) {
                                let logo_id = product_logo_management_object.get_logo_id();
                                self.get_variant_data(self.get_selected_variant(), number_of_items, logo_id);
                            } else if (self.is_tiered_price && self.is_validate_options()) {
                                self.get_master_variant_data(number_of_items);
                            }
                        }

                        const counterCount = $(self.product_counter_input_element);
                        let counter = parseInt(counterCount.val());
                        const minusBtn = $(".counter-btn-minus-js");
                        counterCount.val(++counter);
                        if (counter > self.min_quantity) {
                            minusBtn.prop("disabled", false);
                        }
                    }
                );
        },

        get_inventory_data: function () {
            let self = this;

            let post_data = {
                action: "prodigy-remote-get-inventory-product",
                post_id: $("#product_id").val(),
                nonce: settings.nonce
            };
            clearTimeout(self.timeouInventorytId);
            self.timeouInventorytId = setTimeout(
                function () {
                    $.ajax(
                        {
                            type: "post",
                            data: post_data,
                            dataType: "json",
                            url: ajax_url,
                            success: function (data) {
                                if (typeof data.attributes !== 'undefined') {
                                    self.set_stock_status(data.attributes);
                                }
                            }
                        }
                    );
                },
                500
            );
        },

        set_stock_status: function (inventory, is_variant) {
            let self = this;
            let inventory_quantity = parseInt(localStorage.getItem("items_quantity"));
            if (inventory['manage-stock'] && !inventory['backorderable'] && inventory_quantity > 0) {
                self.maxItems = inventory_quantity;
            }
            if (inventory['manage-stock']) {
                if (($(".attribute_values_js").length !== 0 && !is_variant) || inventory_quantity === 0) {
                    self.set_out_of_stock_status();
                } else {
                    self.disable_minus_button();
                    self.set_in_stock_status(inventory);
                }
            } else if (is_variant && inventory['manage-stock'] && inventory['backorderable'] && inventory['stock'] === 'in_stock' && inventory_quantity === 0) {
                self.set_in_stock_status(inventory);
            } else if (is_variant && !inventory['manage-stock'] && inventory['stock'] === 'in_stock') {
                self.set_in_stock_status(inventory);
            } else if (is_variant && !inventory['manage-stock'] && inventory['stock'] === 'out_of_stock') {
                self.set_out_of_stock_status();
            }
        },

        is_swatches: function () {
            return $(this.prodigy_product_swatch_block_element).length !== 0;
        },


        show_product_data: function (data_object, price, sale_price, subscriptions, inventory = [], items_quantity = 1, is_selected_variant = false) {
            if (!is_selected_variant && $('.main-price-js').text() !== prodigy_price_format(price)) {
                localStorage.setItem('product-range', $('.main-price-js').text().trim());
            }

            this.show_product_price(price, sale_price, data_object.tiered_price, items_quantity, is_selected_variant);

            if (this.is_subscriptions()) {
                this.show_subscription_block(is_selected_variant, subscriptions, price);
                this.format_subscription_price(price);
            }

            this.show_variant_inventory(inventory);
            this.show_variant_sku(data_object);
        },


        show_variant_inventory: function (inventory) {
            if (typeof inventory.attributes !== "undefined") {
                localStorage.setItem("items_quantity", inventory.attributes.count);
                this.show_status(inventory.attributes, true, true);
                this.clear_default_info();
                this.is_variant_was_chosen = true;
                if (this.is_tiered_price) {
                    const counterCount = $(self.product_counter_input_element);
                    let counter = parseInt(counterCount.val());
                    const minusBtn = $(".counter-btn-minus-js");
                    counterCount.val(counter);
                    if (counter > self.min_quantity) {
                        minusBtn.prop("disabled", false);
                    }
                } else if (inventory.attributes['manage-stock']) {
                    this.counter_reset();
                }
            }
        },


        show_subscription_block: function (is_selected_variant, subscriptions, price) {
            let default_info = $('.product-default-info-js');
            default_info.show();
            if (is_selected_variant) {
                default_info.hide();

                if (subscriptions) {
                    $('.prodigy-subscriptions-tab-js:first').trigger('click');
                    $('.prodigy-product__price-wrapper').hide();
                } else {
                    $('.prodigy-product__price-wrapper').show();
                }
                this.show_subscription_price(price);
            } else if (this.is_subscriptions()) {
                $(this.product_default_info_price_element).text('$' + price);
            }
        },

        show_subscription_price: function (price) {
            let sale_price = $('.subscription-sale_price-js').val();
            if (sale_price !== price && typeof sale_price !== 'undefined') {
                let price = this.get_current_product_price();
                let price_string = '$' + prodigy_price_format(price);
                $('.prodigy-product__prop-txt-price').text(price_string).show();
            }
        },

        calculate_product_price: function (start_price, sale_price = null, tiered_price = null, items_quantity = 1) {
            let logo_price = 0;
            let total_price = 0;
            let actual_price = 0;
            let total_price_with_personalization = 0;
            let personalization_price = 0;

            if ((tiered_price !== undefined && (parseFloat(tiered_price) > 0))) {
                actual_price = prodigy_price_format(parseFloat(tiered_price));
                total_price = actual_price * items_quantity;
            } else {
                actual_price = this.get_actual_price(start_price, sale_price);
                total_price = actual_price * items_quantity;
            }

            if (product_logo_management_object.is_logo()) {
                logo_price = product_logo_management_object.get_logos_price() * items_quantity;
                total_price = total_price + logo_price;
            }

            if (this.is_personalization()) {
                if (this.is_personalization_filled()) {
                    personalization_price = this.calculate_personalization_price(actual_price) * items_quantity;
                    total_price = total_price + personalization_price;
                } else {
                    total_price_with_personalization = total_price + this.calculate_personalization_price(actual_price) * items_quantity;
                    $('.prodigy-product__main-price').data('personalization-price', parseFloat(total_price_with_personalization));
                }
            }

            $('.prodigy-product__main-price').data('total-price', total_price);
            return total_price;
        },

        show_product_price: function (price, sale_price, tiered_price, items_quantity, is_selected_variant) {
            let attribute_select = $(".attribute_values_js");
            let subscription_block = $('.subscriptions');
            let main_currency_js = $('.main-price-currency-js');
            let main_price_js = $(".main-price-js");
            let sale_price_info = $(".sale-price-container");
            let regular_price_info = $(".regular-price-container");
            let sale_price_value_block = $(".sale-price");
            let top_product_price = $('.prodigy-product__main-price');
            let master_product_price = $('.prodigy-product__price-wrapper');
            let total_price = this.calculate_product_price(price, sale_price, tiered_price);
            const hasAttributesOrSwatches = attribute_select.length !== 0 || this.is_swatches();
            if (hasAttributesOrSwatches && !is_selected_variant) {
                this.handle_stock_and_price_info(this.product_stock_element, regular_price_info, sale_price_info);
                subscription_block.hide();
                main_currency_js.hide();
                this.set_price_text(main_price_js, localStorage.getItem('product-range'));
            } else {
                const formattedTotalPrice = parseFloat(total_price) >= 0 ? '$' + prodigy_price_format(parseFloat(total_price)) : '';
                this.handle_stock_and_price_info(this.product_stock_element, regular_price_info, sale_price_info);
                if (formattedTotalPrice) {
                    if (this.is_sale_price_valid(sale_price)) {
                        if (price === "") {
                            this.handle_stock_and_price_info(this.product_stock_element, regular_price_info, sale_price_info);
                        } else {
                            this.set_price_text(main_price_js, formattedTotalPrice);
                            this.show_elements(regular_price_info, sale_price_info, $(this.product_stock_element));
                        }
                        regular_price_info.hide();

                        if (product_logo_management_object.is_logo() || this.is_personalization()) {
                            sale_price_value_block.text(formattedTotalPrice);
                            top_product_price.text(formattedTotalPrice);
                            master_product_price.text(formattedTotalPrice);
                            regular_price_info.hide();
                        } else {
                            if (!sale_price) {
                                sale_price_info.show();
                                if (price) {
                                    sale_price_value_block.text(formattedTotalPrice);
                                    top_product_price.text(formattedTotalPrice);
                                    master_product_price.text(formattedTotalPrice);
                                    regular_price_info.hide();
                                }
                            } else {
                                sale_price_value_block.text(formattedTotalPrice);
                            }
                        }

                        regular_price_info.hide();
                    } else {
                        this.handle_stock_and_price_info(this.product_stock_element, regular_price_info, sale_price_info);
                    }
                } else {
                    this.handle_stock_and_price_info(this.product_stock_element, regular_price_info, sale_price_info);
                }
            }
        },

        hide_elements: function (...elements) {
            elements.forEach(function (element) {
                if (typeof $(element) !== "undefined") {
                    $(element).hide();
                }
            });
        },

        show_elements: function (...elements) {
            elements.forEach(function (element) {
                if (typeof $(element) !== "undefined") {
                    $(element).show();
                }
            });
        },

        set_price_text: function (priceElement, price) {
            priceElement.text(price);
        },

        is_sale_price_valid: function (salePrice) {
            return typeof salePrice !== "undefined";
        },

        handle_stock_and_price_info: function (stock_info, regular_price_info, sale_price_info) {
            this.hide_elements(stock_info, regular_price_info, sale_price_info);
        },


        input_personalization_field: function () {
            let self = this;

            $(this.prodigy_personalization_input_element).on('input', function () {
                if (prodigyProductBulk.is_active_logo_bulk) {
                    let bulk_data = $('#variant-data-js').data('bulk-variants');
                    prodigyProductBulk.update_bulk_price(bulk_data);
                    self.update_bulk_info(bulk_data.result);
                } else {
                    if (self.is_variants()) {
                        let variant_data = $('#variant-data-js').data('variant');
                        self.set_variants_data(variant_data);
                        self.set_product_data_for_cart(variant_data);
                        self.set_shipping_data(variant_data);
                        self.disable_add_to_cart_button_loader();
                        if (!self.is_bulk_opened() && !self.is_variant_was_chosen) {
                            self.set_tiered_prices(variant_data);
                        }
                    } else {
                        self.show_master_variant_info();
                    }
                }
            });

        },

        is_personalization_filled: function () {
            let is_personalization_filled = false;
            $(this.prodigy_personalization_input_element).each(function () {
                if ($(this).val().length > 0) {
                    is_personalization_filled = true;
                }
            });

            return is_personalization_filled;
        },

        is_personalization: function () {
            return $('#personalization-price-modifier-js').length > 0;
        },

        is_valid_personalization_price: function (value) {
            return value !== undefined && value !== null && value !== '' && !isNaN(value);
        },

        calculate_personalization_price: function (price) {
            let personalization_modifier_type = $('#personalization-price-modifier-js').val();
            let personalization_modifier_value = $('#personalization-price-value-js').val();
            let personalization_price = 0;

            if (
                personalization_modifier_type &&
                this.is_valid_personalization_price(personalization_modifier_value)
            ) {
                if (personalization_modifier_type === 'flat') {
                    personalization_price = parseFloat(personalization_modifier_value);
                } else {
                    personalization_price = prodigy_price_format((parseFloat(price) * personalization_modifier_value) / 100);
                }
            }

            return personalization_price;
        },

        show_master_variant_info: function () {
            let self = this;
            if (
                typeof this.remote_product !== "undefined" &&
                this.remote_product.remote_main_price !== null
            ) {

                let subscriptions = false;
                if (typeof this.remote_product.remote_master_variant_info !== 'undefined') {
                    subscriptions = typeof this.remote_product.remote_master_variant_info['subscription-plan'] !== 'undefined';
                }

                let price = 0;
                let sale_price = 0;
                if (typeof this.remote_product.remote_main_price !== 'undefined') {
                    price = this.remote_product.remote_main_price.price;
                    sale_price = this.remote_product.remote_main_price['sale-price'];

                    this.show_product_data(
                        this.remote_product,
                        price,
                        sale_price,
                        subscriptions,
                        this.remote_product.remote_master_variant_info.inventory,
                        this.get_quantity_of_products()
                    );
                }

                self.show_master_product_info();
            }
        },


        show_master_product_info: function () {
            let self = this;
            if (
                typeof this.remote_product !== 'undefined' &&
                typeof this.remote_product.remote_master_variant_info !== "undefined" &&
                this.remote_product.remote_master_variant_info.inventory &&
                typeof this.remote_product.remote_master_variant_info.inventory.attributes !== "undefined"
            ) {
                localStorage.setItem("items_quantity", this.remote_product.remote_master_variant_info.inventory.attributes.count);
            }

            if (!self.is_variants()) {
                self.hide_cart_button_loader();
            }

            if (
                typeof this.remote_product.remote_master_variant_info !== 'undefined'
                && typeof this.remote_product.remote_master_variant_info.inventory !== 'undefined'
            ) {
                this.show_status(this.remote_product.remote_master_variant_info.inventory.attributes, self.is_variants(), false);
                self.clear_default_info();
            }

            if (
                this.product.meta &&
                typeof this.product.meta.product_sku !== "undefined" &&
                this.product.meta.product_sku[0]
            ) {
                var main_product_sku = this.product.meta.product_sku[0];
                $(".product_sku_value").text(main_product_sku);
            }

            if (!self.is_subscriptions()) {
                self.is_one_time_order = true;
            }

            self.load_subscription_price();
        },


        get_tiered_prices_range_ajax: function () {
            let self = this;
            let post_data = {
                action: "prodigy-get-tiered-prices-range",
                product_id: this.master_variant_id,
                nonce: settings.nonce
            };

            clearTimeout(self.timeoutTieredtId);
            self.timeoutTieredtId = setTimeout(function () {
                $.ajax({
                    type: "post",
                    data: post_data,
                    dataType: "json",
                    url: ajax_url,
                    success: function (data) {
                        self.min_quantity = data.data.min_quantity;
                        $(self.product_counter_input_element).val(data.data.min_quantity);
                        if (self.is_tiered_price && !self.is_variant_was_chosen) {
                            localStorage.setItem("min_quantity", data.data.min_quantity);
                            $(document).find(".counter-btn-minus-js").prop("disabled", true);
                        }
                        if (parseFloat(data.data.min_price) !== parseFloat(data.data.max_price)) {
                            let range_price_string = 'From $' + prodigy_price_format(data.data.min_price) + ' to $' + prodigy_price_format(data.data.max_price);
                            $('.prodigy-product__main-price').text(range_price_string);
                        }
                    }
                });
            }, 500);
        },

        show_status: function (inventory, has_variant, select_variant) {
            let self = this;
            let inventory_quantity = parseInt(localStorage.getItem("items_quantity"));
            if (typeof inventory_quantity !== "undefined" && inventory['manage-stock']) {
                self.maxItems = inventory_quantity;
            }
            let is_variant = (has_variant && select_variant) || !has_variant;

            if (typeof inventory.stock !== "undefined") {
                self.set_stock_status(inventory, is_variant);
            }
        },

        clear_default_info: function () {
            $(this.product_default_info_price_element).hide();
            $('.product-default-info-js').hide();
        },

        disable_minus_button: function () {
            var minus = $(".counter-btn-minus-js");

            if (parseInt($(self.product_counter_input_element).val()) === self.min_quantity) {
                minus.prop("disabled", true);
            } else {
                minus.prop("disabled", false);
            }
        },

        set_out_of_stock_status: function () {
            $(this.product_stock_element).text(this._stock_status_mapper['out_of_stock']);
        },

        set_in_stock_status: function (inventory) {
            let plus = $(".counter-btn-plus-js");
            let count_input = $(self.product_counter_input_element);
            count_input.prop("disabled", false);
            plus.prop("disabled", false);
            $(this.add_to_cart_button_element).prop("disabled", false);
            let counter = inventory.count !== null ? inventory.count : '';
            $(this.product_stock_element).show();
            $(this.product_stock_element).text(this._stock_status_mapper[inventory.stock] + ' ' + counter);
        },

        get_actual_price: function (price, sale_price) {
            if (sale_price === '' || !sale_price) {
                return parseFloat(price);
            } else {
                return parseFloat(sale_price);
            }
        },

        set_variants_data: function (data) {
            let self = this;
            if (typeof data !== 'undefined') {

                if (settings.pg_google_track_id !== "" && typeof settings.pg_google_track_id !== "undefined") {
                    self.set_view_product_analytic_event(data);
                }

                if (typeof data.inventory !== "undefined" && typeof data.inventory.attributes.count !== "undefined") {
                    this.show_product_data(
                        data.attributes,
                        data.attributes.price,
                        data.attributes['sale-price'],
                        data['subscription-plan'],
                        data.inventory,
                        this.get_quantity_of_products(),
                        true
                    );
                }

                self.load_subscription_price();
            }
        },

        show_variant_sku: function (attributes) {
            let sku;
            if (
                typeof attributes !== "undefined" &&
                attributes.sku
            ) {
                sku = attributes.sku;
            }

            if (sku !== "" && typeof sku !== "undefined") {
                $(".product_sku_value").text(sku);
            } else {
                $(".prodigy-product__tags-item product_sku").hide();
            }
        },

        set_product_data_for_cart: function (data_variant) {
            let self = this;
            if (typeof data_variant !== "undefined") {
                if (typeof data_variant.remote_variant_id !== "undefined") {
                    $(self.add_to_cart_button_element).attr("data-remote-id", data_variant.remote_variant_id);
                }

                if (typeof data_variant.local_variant_id !== "undefined") {
                    $(self.add_to_cart_button_element).attr("data-local-id", data_variant.local_variant_id);
                }
            }
        },

        /**
         * Get obj remote product info
         *
         * @version 2.0.0
         */
        get_master_variant_data: function (number_of_items = 1) {
            let post_data = {
                action: "prodigy-get-master-variant-data",
                post_id: this.master_variant_id,
                items_number: number_of_items,
                nonce: settings.nonce
            };

            let self = this;

            $.ajax(
                {
                    type: "post",
                    data: post_data,
                    dataType: "json",
                    url: ajax_url,
                    success: function (data) {
                        self.remote_product = data.data;
                        if (typeof settings.is_captcha !== 'undefined' &&
                            settings.is_captcha !== '' &&
                            typeof settings.captcha_site_key !== 'undefined' &&
                            settings.captcha_site_key !== ''
                        ) {
                            let is_admin = $(document).find('#user-role-js').data('attr');
                            if (!is_admin) {
                                grecaptcha.render(
                                    'captcha',
                                    {
                                        'sitekey': settings.captcha_site_key
                                    }
                                );
                            }
                        }

                        if (typeof data.data !== 'undefined') {
                            self.variant = data.data.remote_master_variant_info;
                        }
                        self.show_master_variant_info();
                        self.add_item_to_cart();
                    }
                }
            );
        },

        show_tab_description: function () {
            $("body").on(
                "click",
                ".show-description-js",
                function () {
                    $(".description_tab").addClass("active").show();
                    $("#tab-description").show();
                    $("#tab-li-reviews").removeClass("active");
                    $(".additional_information_tab").removeClass("active");
                    $(".reviews_tab").removeClass("active");
                    $(".tiered_prices_tab").removeClass("active");
                    $("#tab-additional_information").hide();
                    $("#tab-reviews").hide();
                    $("#tab-tiered_prices").hide();
                }
            );
        },

        show_tab_review: function () {
            $("body").on(
                "click",
                ".prodigy-review-link-js",
                function () {
                    $("#tab-reviews").addClass("active").show();
                    $("#tab-li-reviews").addClass("active");
                    $("#tab-description").hide();
                    $("#tab-additional_information").hide();
                    $("#tab-tiered_prices").hide();
                    $(".description_tab").removeClass("active");
                    $(".tiered_prices_tab").removeClass("active");
                    $(".additional_information_tab").removeClass("active");
                    $(".reviews_tab").addClass("active");
                    if (document.getElementById("tab-reviews")) {
                        document.getElementById("tab-reviews").scrollIntoView();
                    }
                }
            );
        },

        set_product_tabs: function () {
            $(".description_tab").addClass("active");
            $("#tab-additional_information").hide();
            $("#tab-reviews").hide();

            $(document).on(
                'click',
                '.tiered_prices_tab',
                function () {
                    $('html,body').animate({scrollTop: $(this).offset().top}, 500);
                }
            );

            $("body")
                // Tabs
                .on(
                    "init",
                    ".prodigy-tabs-js, .prodigy-tabs",
                    function () {
                        $(".pg-tab, .prodigy-tabs .panel:not(.panel .panel)").hide();
                        var hash = window.location.hash;
                        var url = window.location.href;
                        var $tabs = $(this)
                            .find(".pg-tabs, ul.tabs")
                            .first();
                        if (
                            hash.toLowerCase().indexOf("comment-") >= 0 ||
                            hash === "#reviews" ||
                            hash === "#tab-reviews"
                        ) {
                            $tabs.find("li.reviews_tab a").click();
                        } else if (
                            url.indexOf("comment-page-") > 0 ||
                            url.indexOf("cpage=") > 0
                        ) {
                            $tabs.find("li.reviews_tab a").click();
                        } else if (hash === "#tab-additional_information") {
                            $tabs.find("li.additional_information_tab a").click();
                        } else {
                            var $tab = $tabs.find("li:first a");
                            var $tabs_wrapper = $tab.closest(".prodigy-tabs-js, .prodigy-tabs");
                            $tabs.find("li").removeClass("active");
                            $tabs_wrapper.find(".pg-tab, .panel:not(.panel .panel)").hide();

                            $tab.addClass("active");
                            $tabs_wrapper.find($tab.data("href")).show();
                        }
                    }
                )
                .on(
                    "click",
                    ".pg-tabs li a, ul.tabs li a",
                    function (e) {
                        var $tab = $(this);
                        var $tabs_wrapper = $tab.closest(".prodigy-tabs-js, .prodigy-tabs");
                        var $tabs = $tabs_wrapper.find(".pg-tabs, ul.tabs");

                        $tabs.find("li").removeClass("active");
                        $tabs_wrapper.find(".pg-tab, .panel:not(.panel .panel)").hide();

                        $tab.closest("li").addClass("active");
                        $tabs_wrapper.find($tab.data("href")).show();
                    }
                )

                // Star ratings for comments
                .on(
                    "init",
                    "#prodigy-rating",
                    function () {
                        $(this)
                            .hide()
                            .before(
                                "" +
                                '<div class="stars prodigy-comment__rating">' +
                                '<a class="star-1 prodigy-comment__star icon icon-star" href="#">1</a>' +
                                '<a class="star-2 prodigy-comment__star icon icon-star" href="#">2</a>' +
                                '<a class="star-3 prodigy-comment__star icon icon-star" href="#">3</a>' +
                                '<a class="star-4 prodigy-comment__star icon icon-star" href="#">4</a>' +
                                '<a class="star-5 prodigy-comment__star icon icon-star" href="#">5</a>' +
                                "</div>"
                            );
                    }
                )
                .on(
                    "click",
                    "#respond div.stars a",
                    function () {
                        var $star = $(this),
                            $rating = $(this)
                                .closest("#respond")
                                .find("#prodigy-rating"),
                            $container = $(this).closest(".stars");
                        $rating.val($star.text()).trigger("change");
                        $star.siblings("a").removeClass("active");
                        $star.addClass("active");
                        $container.addClass("selected");

                        return false;
                    }
                )

                .on(
                    "click",
                    "#reviews #comments .justify-content-center",
                    function () {
                        window.prodigyProduct
                            .get_count_review()
                            .done(
                                function (result) {
                                    let count_review = result.data;
                                    if (count_review > 0) {
                                        window.prodigyProduct.get_content_review();
                                    }
                                }
                            )
                            .fail(
                                function () {
                                }
                            );
                    }
                );

            $(".prodigy-tabs-js, .prodigy-tabs, #prodigy-rating").trigger("init");
        },

        get_content_review: function () {
            let self = $("#reviews #comments .justify-content-center");
            let page = $(".per-page-js").data("page");
            let post_data = {
                action: "prodigy-public-get-comments",
                post_id: $("#product_id").val(),
                page: page,
                nonce: settings.nonce
            };

            $.ajax(
                {
                    type: "post",
                    data: post_data,
                    dataType: "text",
                    url: ajax_url,
                    success: function (data) {
                        self.before(data);
                        $(".per-page-js").data("page", page + 1);

                        window.prodigyProduct.get_count_review().done(
                            function (res) {
                                if (res.data === 0) {
                                    window.prodigyProduct.hide_link_show_more_reviews();
                                }
                            }
                        );
                    }
                }
            );
        },

        get_count_review: function () {
            let post_data = {
                action: "prodigy-public-get-comments-count",
                post_id: $("#product_id").val(),
                page: $(".per-page-js").data("page"),
                nonce: settings.nonce
            };

            return $.ajax(
                {
                    type: "post",
                    data: post_data,
                    dataType: "json",
                    url: ajax_url
                }
            );
        },

        hide_link_show_more_reviews: function () {
            $(".link-show-more-reviews-js")
                .removeClass("d-flex")
                .addClass("d-none");
        },

        set_default_link_review: function () {
            window.prodigyProduct.get_count_review().done(
                function (res) {
                    if (res.data === 0) {
                        window.prodigyProduct.hide_link_show_more_reviews();
                    }
                }
            );
        },

        init_show_more: function () {
            $("body").on(
                "click",
                ".prodigy-product__description-show-more",
                function () {
                    var $container = $(this).parent();
                    $container
                        .find(".prodigy-product__description-container")
                        .removeClass("prodigy-product__description-container--truncated");
                    $container.find(".prodigy-product__description-fade").remove();
                    $(this).remove();
                }
            );
        },

        set_customised_variant_selection: function () {
            $(document).find('select[data-attribute]').trigger('focus');
        },

        customise_sort_select: function () {
            $('.prodigy-custom-select').styler(
                {
                    onFormStyled: function () {
                        $('.jq-selectbox__select-text').each(
                            function () {
                                const width = $(this)
                                    .closest('.jq-selectbox')
                                    .find('select')
                                    .width();
                                $(this).width(width);
                            }
                        );
                    }
                }
            );
        },

        is_validate_options: function () {
            let result = true;
            let self = this;
            $('.bulk-container-js:visible').each(
                function (i, bulk_container) {
                    let bulk_result = false;
                    $(bulk_container).find(prodigyProductBulk.input_bulk_quantity_element).each(
                        function (index, input) {
                            if ($(input).val() !== "") {
                                bulk_result = true;
                            } else {
                                bulk_result = bulk_result || false;
                            }
                        }
                    );
                    result = result && bulk_result;
                }
            );

            $('.attribute_values_js').each(
                function (e) {
                    if (!$(this).hasClass('ignored')) {
                        if ($(this).val() === "") {
                            result = false;
                        } else {
                            result = result && true;
                        }
                    }
                }
            );

            $(self.prodigy_product_swatch_block_element).each(
                function () {
                    let self = this;
                    let checkbox = $(this).find('.prodigy-product__swatch-js');
                    checkbox.each(
                        function () {
                            if (!checkbox.is(':checked') && !$(self).hasClass('ignored')) {
                                result = false;
                            } else {
                                result = result && true;
                            }
                        }
                    );
                }
            );

            return result;
        },

        validate_options: function () {
            let result = true;
            let self = this;
            $('.bulk-container-js:visible').each(
                function (i, bulk_container) {
                    let bulk_result = false;
                    $(bulk_container).find(prodigyProductBulk.input_bulk_quantity_element).each(
                        function (index, input) {
                            if ($(input).val() !== "") {
                                bulk_result = true;
                            } else {
                                bulk_result = bulk_result || false;
                            }
                        }
                    );
                    const headers = $(bulk_container).find('.prodigy-tooltip, .prodigy-bulk__table-cell');
                    bulk_result ? headers.removeAttr('style') : headers.css('border-color', 'red')
                    result = result && bulk_result;
                }
            );

            $('.attribute_values_js').each(function (e) {
                    if (!$(this).hasClass('ignored') && $(this).val() === "") {
                        $(this).parent().parent().prev().prev().css('color', 'red');
                        result = false;
                    } else {
                        $(this).parent().parent().prev().prev().removeAttr('style');
                        result = result && true;
                    }
                }
            );

            $('.prodigy-product__swatch-block-js:not(.ignored)').each(
                function () {
                    let element = $(this).closest('.prodigy-product__attr-item--no-select-value').find('.prodigy-product__attr-text');
                    let checkbox = $(this).find(self.prodigy_product_swatch_element);
                    checkbox.each(
                        function () {
                            if (!checkbox.is(':checked')) {
                                element.css('color', 'red');
                                result = false;
                            } else {
                                element.removeAttr('style');
                                result = result && true;
                            }
                        }
                    );
                }
            );

            return result;
        },
        hide_empty_div: function () {
            $('.prodigy-product__prop-wrap').each(function () {
                    if ($.trim($(this).text()) == '' && $(this).children().length == 0) {
                        $(this).hide();
                    }
                }
            );
        },
    };

    window.prodigyProduct = prodigy_product;
})(jQuery, window);

jQuery(document).ready(
    function ($) {
        window.prodigyProduct.init();
        window.prodigyRecaptchaCallback = window.prodigyProduct.captcha_callback.bind(
            window.prodigyProduct
        );
    }
);
